import {
  Arr
} from '../../Array.lib';
import {
  Obj
} from '../../Object.lib';
import fetchResumeHighlightsConfiguration from './fetchResumeHighlightsConfiguration.fun';
import {
  KEY__RESUME_HIGHLIGHTS__NON_COMPLEX_TASKS_LIST
} from './getDefaultModelResumeHighlights.fun';

export default async function fetchResumeHighlightsNonComplexTasksList() {
  return Arr(
    Obj(
      Obj(
        await fetchResumeHighlightsConfiguration()
      ).value
    )[KEY__RESUME_HIGHLIGHTS__NON_COMPLEX_TASKS_LIST]
  );
}
